export const BRA = 'bra'
export const COL = 'col'
export const CRI = 'cri'
export const ESP = 'esp'
export const USA = 'usa'

export const WHITELISTED_COUNTRY_SELECTION_MODAL = [BRA, COL, CRI, ESP]
